import styled from "styled-components";
// * Icons
import { RiMotorbikeFill } from "react-icons/ri";
import { BiSupport } from "react-icons/bi";
import { AiOutlineSafety } from "react-icons/ai";

export const Container = styled.div`
  z-index: 1;
  width: 100%;
  max-width: 1300px;
  margin-right: auto;
  margin-left: auto;
  padding: 100px;
  margin-top: 100px;

  @media screen and (max-width: 991px) {
    padding-right: 40px;
    padding-left: 40px;
  }
`;

export const Truck = styled(RiMotorbikeFill)`
  font-size: 50px;
  @media screen and (max-width: 700px) {
    font-size: 30px;
  }
`;
export const Support = styled(BiSupport)`
  font-size: 50px;
  @media screen and (max-width: 700px) {
    font-size: 30px;
  }
`;
export const Guarantee = styled(AiOutlineSafety)`
  font-size: 50px;
  @media screen and (max-width: 700px) {
    font-size: 30px;
  }
`;

export const IconSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  text-align: center;
  @media screen and (max-width: 700px) {
    justify-content: space-between;
  }
`;

export const Text = styled.p`
  font-size: 15px;
  font-weight: bold;
  @media screen and (max-width: 700px) {
    font-size: 13px;
  }
`;

export const IconWrapper = styled.div`
  color: #adb5bd;
  transition: all 0.5s ease;

  &:hover {
    color: #3d5a80;
    transition: all 0.5s ease;
    cursor: pointer;
  }
`;
